/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Terms and Conditions */
$(document).ready(function () {

  function allRequiredChecked() {
    let allChecked = true;

    $('.cart-notification-checkbox').each(function () {
      if (!$(this).is(':checked')) {
        allChecked = false;
      }
    });

    return allChecked;
  }

  function toggleCheckoutButton() {
    if (allRequiredChecked()) {
      $("#checkout")
        .removeClass('button--disabled')
        .addClass('button--primary');
    } else {
      $("#checkout")
        .removeClass('button--primary')
        .addClass('button--disabled');
    }
  }

  // Update checkout button state on checkbox change
  $('.cart-notification-checkbox').on('change', toggleCheckoutButton);

  // Intercept checkout click
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function (e) {
    if (!allRequiredChecked()) {
      e.preventDefault(); // prevent checkout
      alert("Please check all required boxes before proceeding."); // single alert message
      return false;
    }
  });

  // Initialize button state on page load
  toggleCheckoutButton();
});





/* Contact Form Hide/Show Order # Field */
function yesnoCheck(that) {
    if (that.value == "Order Issues") {
        document.getElementById("ifYes").style.display = "block";
    } else {
        document.getElementById("ifYes").style.display = "none";
      document.getElementById("contact-form-order-number").required = false;
    }
}



